
import React from 'react';
import InvoicesView from '../../../components/InvoicesView';

interface RechnungenListeProps {
  userProfile?: any;
  onNavigateToObjekt?: (id: string) => void;
}

const RechnungenListe: React.FC<RechnungenListeProps> = ({ userProfile, onNavigateToObjekt }) => {
  return (
    <InvoicesView
      userProfile={userProfile}
      onNavigateToObjekt={onNavigateToObjekt}
    />
  );
};

export default RechnungenListe;
